import type { RootState } from '@redux/store'

export const carryForwardSelector = (state: RootState) =>
  state.settingCarryForward
